// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__SMNxe","productName":"Table_productName__3iy8m"};